export interface CountryCode {
  name:    string;
  code:    string;
  iso:     string;
  flag:    string;
  format?: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { name: "Afghanistan",              code: "+93",   iso: "AF", flag: "🇦🇫" },
  { name: "Albania",                  code: "+355",  iso: "AL", flag: "🇦🇱" },
  { name: "Algeria",                  code: "+213",  iso: "DZ", flag: "🇩🇿" },
  { name: "Andorra",                  code: "+376",  iso: "AD", flag: "🇦🇩" },
  { name: "Angola",                   code: "+244",  iso: "AO", flag: "🇦🇴" },
  { name: "Argentina",                code: "+54",   iso: "AR", flag: "🇦🇷" },
  { name: "Armenia",                  code: "+374",  iso: "AM", flag: "🇦🇲" },
  { name: "Australia",                code: "+61",   iso: "AU", flag: "🇦🇺", format: "XXX XXX XXX" },
  { name: "Austria",                  code: "+43",   iso: "AT", flag: "🇦🇹" },
  { name: "Azerbaijan",               code: "+994",  iso: "AZ", flag: "🇦🇿" },
  { name: "Bahrain",                  code: "+973",  iso: "BH", flag: "🇧🇭", format: "XXXX XXXX" },
  { name: "Bangladesh",               code: "+880",  iso: "BD", flag: "🇧🇩", format: "XXXX XXXXXX" },
  { name: "Belarus",                  code: "+375",  iso: "BY", flag: "🇧🇾" },
  { name: "Belgium",                  code: "+32",   iso: "BE", flag: "🇧🇪" },
  { name: "Bolivia",                  code: "+591",  iso: "BO", flag: "🇧🇴" },
  { name: "Bosnia and Herzegovina",   code: "+387",  iso: "BA", flag: "🇧🇦" },
  { name: "Brazil",                   code: "+55",   iso: "BR", flag: "🇧🇷", format: "XX XXXXX XXXX" },
  { name: "Bulgaria",                 code: "+359",  iso: "BG", flag: "🇧🇬" },
  { name: "Cambodia",                 code: "+855",  iso: "KH", flag: "🇰🇭" },
  { name: "Cameroon",                 code: "+237",  iso: "CM", flag: "🇨🇲" },
  { name: "Canada",                   code: "+1",    iso: "CA", flag: "🇨🇦", format: "XXX XXX XXXX" },
  { name: "Chile",                    code: "+56",   iso: "CL", flag: "🇨🇱" },
  { name: "China",                    code: "+86",   iso: "CN", flag: "🇨🇳", format: "XXX XXXX XXXX" },
  { name: "Colombia",                 code: "+57",   iso: "CO", flag: "🇨🇴" },
  { name: "Congo (DRC)",              code: "+243",  iso: "CD", flag: "🇨🇩" },
  { name: "Costa Rica",               code: "+506",  iso: "CR", flag: "🇨🇷" },
  { name: "Croatia",                  code: "+385",  iso: "HR", flag: "🇭🇷" },
  { name: "Cuba",                     code: "+53",   iso: "CU", flag: "🇨🇺" },
  { name: "Cyprus",                   code: "+357",  iso: "CY", flag: "🇨🇾" },
  { name: "Czech Republic",           code: "+420",  iso: "CZ", flag: "🇨🇿" },
  { name: "Denmark",                  code: "+45",   iso: "DK", flag: "🇩🇰" },
  { name: "Dominican Republic",       code: "+1809", iso: "DO", flag: "🇩🇴" },
  { name: "Ecuador",                  code: "+593",  iso: "EC", flag: "🇪🇨" },
  { name: "Egypt",                    code: "+20",   iso: "EG", flag: "🇪🇬", format: "XXX XXX XXXX" },
  { name: "El Salvador",              code: "+503",  iso: "SV", flag: "🇸🇻" },
  { name: "Estonia",                  code: "+372",  iso: "EE", flag: "🇪🇪" },
  { name: "Ethiopia",                 code: "+251",  iso: "ET", flag: "🇪🇹" },
  { name: "Finland",                  code: "+358",  iso: "FI", flag: "🇫🇮" },
  { name: "France",                   code: "+33",   iso: "FR", flag: "🇫🇷", format: "X XX XX XX XX" },
  { name: "Georgia",                  code: "+995",  iso: "GE", flag: "🇬🇪" },
  { name: "Germany",                  code: "+49",   iso: "DE", flag: "🇩🇪" },
  { name: "Ghana",                    code: "+233",  iso: "GH", flag: "🇬🇭" },
  { name: "Greece",                   code: "+30",   iso: "GR", flag: "🇬🇷" },
  { name: "Guatemala",                code: "+502",  iso: "GT", flag: "🇬🇹" },
  { name: "Honduras",                 code: "+504",  iso: "HN", flag: "🇭🇳" },
  { name: "Hong Kong",                code: "+852",  iso: "HK", flag: "🇭🇰", format: "XXXX XXXX" },
  { name: "Hungary",                  code: "+36",   iso: "HU", flag: "🇭🇺" },
  { name: "Iceland",                  code: "+354",  iso: "IS", flag: "🇮🇸" },
  { name: "India",                    code: "+91",   iso: "IN", flag: "🇮🇳", format: "XXXXX XXXXX" },
  { name: "Indonesia",                code: "+62",   iso: "ID", flag: "🇮🇩" },
  { name: "Iran",                     code: "+98",   iso: "IR", flag: "🇮🇷" },
  { name: "Iraq",                     code: "+964",  iso: "IQ", flag: "🇮🇶" },
  { name: "Ireland",                  code: "+353",  iso: "IE", flag: "🇮🇪" },
  { name: "Israel",                   code: "+972",  iso: "IL", flag: "🇮🇱" },
  { name: "Italy",                    code: "+39",   iso: "IT", flag: "🇮🇹" },
  { name: "Jamaica",                  code: "+1876", iso: "JM", flag: "🇯🇲" },
  { name: "Japan",                    code: "+81",   iso: "JP", flag: "🇯🇵", format: "XX XXXX XXXX" },
  { name: "Jordan",                   code: "+962",  iso: "JO", flag: "🇯🇴" },
  { name: "Kazakhstan",               code: "+7",    iso: "KZ", flag: "🇰🇿" },
  { name: "Kenya",                    code: "+254",  iso: "KE", flag: "🇰🇪", format: "XXX XXX XXX" },
  { name: "Korea (South)",            code: "+82",   iso: "KR", flag: "🇰🇷", format: "XX XXXX XXXX" },
  { name: "Kuwait",                   code: "+965",  iso: "KW", flag: "🇰🇼", format: "XXXX XXXX" },
  { name: "Kyrgyzstan",               code: "+996",  iso: "KG", flag: "🇰🇬" },
  { name: "Laos",                     code: "+856",  iso: "LA", flag: "🇱🇦" },
  { name: "Latvia",                   code: "+371",  iso: "LV", flag: "🇱🇻" },
  { name: "Lebanon",                  code: "+961",  iso: "LB", flag: "🇱🇧" },
  { name: "Libya",                    code: "+218",  iso: "LY", flag: "🇱🇾" },
  { name: "Lithuania",                code: "+370",  iso: "LT", flag: "🇱🇹" },
  { name: "Luxembourg",               code: "+352",  iso: "LU", flag: "🇱🇺" },
  { name: "Malaysia",                 code: "+60",   iso: "MY", flag: "🇲🇾", format: "XX XXXX XXXX" },
  { name: "Maldives",                 code: "+960",  iso: "MV", flag: "🇲🇻" },
  { name: "Mexico",                   code: "+52",   iso: "MX", flag: "🇲🇽", format: "XXX XXX XXXX" },
  { name: "Moldova",                  code: "+373",  iso: "MD", flag: "🇲🇩" },
  { name: "Mongolia",                 code: "+976",  iso: "MN", flag: "🇲🇳" },
  { name: "Morocco",                  code: "+212",  iso: "MA", flag: "🇲🇦" },
  { name: "Mozambique",               code: "+258",  iso: "MZ", flag: "🇲🇿" },
  { name: "Myanmar",                  code: "+95",   iso: "MM", flag: "🇲🇲" },
  { name: "Nepal",                    code: "+977",  iso: "NP", flag: "🇳🇵", format: "XXX XXXXXXX" },
  { name: "Netherlands",              code: "+31",   iso: "NL", flag: "🇳🇱" },
  { name: "New Zealand",              code: "+64",   iso: "NZ", flag: "🇳🇿" },
  { name: "Nicaragua",                code: "+505",  iso: "NI", flag: "🇳🇮" },
  { name: "Nigeria",                  code: "+234",  iso: "NG", flag: "🇳🇬", format: "XXX XXX XXXX" },
  { name: "North Macedonia",          code: "+389",  iso: "MK", flag: "🇲🇰" },
  { name: "Norway",                   code: "+47",   iso: "NO", flag: "🇳🇴" },
  { name: "Oman",                     code: "+968",  iso: "OM", flag: "🇴🇲", format: "XXXX XXXX" },
  { name: "Pakistan",                 code: "+92",   iso: "PK", flag: "🇵🇰", format: "XXX XXXXXXX" },
  { name: "Panama",                   code: "+507",  iso: "PA", flag: "🇵🇦" },
  { name: "Paraguay",                 code: "+595",  iso: "PY", flag: "🇵🇾" },
  { name: "Peru",                     code: "+51",   iso: "PE", flag: "🇵🇪" },
  { name: "Philippines",              code: "+63",   iso: "PH", flag: "🇵🇭", format: "XXX XXX XXXX" },
  { name: "Poland",                   code: "+48",   iso: "PL", flag: "🇵🇱" },
  { name: "Portugal",                 code: "+351",  iso: "PT", flag: "🇵🇹" },
  { name: "Qatar",                    code: "+974",  iso: "QA", flag: "🇶🇦", format: "XXXX XXXX" },
  { name: "Romania",                  code: "+40",   iso: "RO", flag: "🇷🇴" },
  { name: "Russia",                   code: "+7",    iso: "RU", flag: "🇷🇺", format: "XXX XXX XX XX" },
  { name: "Rwanda",                   code: "+250",  iso: "RW", flag: "🇷🇼" },
  { name: "Saudi Arabia",             code: "+966",  iso: "SA", flag: "🇸🇦", format: "5X XXX XXXX" },
  { name: "Senegal",                  code: "+221",  iso: "SN", flag: "🇸🇳" },
  { name: "Serbia",                   code: "+381",  iso: "RS", flag: "🇷🇸" },
  { name: "Singapore",                code: "+65",   iso: "SG", flag: "🇸🇬", format: "XXXX XXXX" },
  { name: "Slovakia",                 code: "+421",  iso: "SK", flag: "🇸🇰" },
  { name: "Slovenia",                 code: "+386",  iso: "SI", flag: "🇸🇮" },
  { name: "Somalia",                  code: "+252",  iso: "SO", flag: "🇸🇴" },
  { name: "South Africa",             code: "+27",   iso: "ZA", flag: "🇿🇦", format: "XX XXX XXXX" },
  { name: "Spain",                    code: "+34",   iso: "ES", flag: "🇪🇸" },
  { name: "Sri Lanka",                code: "+94",   iso: "LK", flag: "🇱🇰", format: "XX XXX XXXX" },
  { name: "Sudan",                    code: "+249",  iso: "SD", flag: "🇸🇩" },
  { name: "Sweden",                   code: "+46",   iso: "SE", flag: "🇸🇪" },
  { name: "Switzerland",              code: "+41",   iso: "CH", flag: "🇨🇭" },
  { name: "Syria",                    code: "+963",  iso: "SY", flag: "🇸🇾" },
  { name: "Taiwan",                   code: "+886",  iso: "TW", flag: "🇹🇼" },
  { name: "Tanzania",                 code: "+255",  iso: "TZ", flag: "🇹🇿" },
  { name: "Thailand",                 code: "+66",   iso: "TH", flag: "🇹🇭", format: "X XXXX XXXX" },
  { name: "Tunisia",                  code: "+216",  iso: "TN", flag: "🇹🇳" },
  { name: "Turkey",                   code: "+90",   iso: "TR", flag: "🇹🇷", format: "XXX XXX XXXX" },
  { name: "Uganda",                   code: "+256",  iso: "UG", flag: "🇺🇬" },
  { name: "Ukraine",                  code: "+380",  iso: "UA", flag: "🇺🇦" },
  { name: "United Arab Emirates",     code: "+971",  iso: "AE", flag: "🇦🇪", format: "5X XXX XXXX" },
  { name: "United Kingdom",           code: "+44",   iso: "GB", flag: "🇬🇧", format: "XXXX XXXXXX" },
  { name: "United States",            code: "+1",    iso: "US", flag: "🇺🇸", format: "XXX XXX XXXX" },
  { name: "Uruguay",                  code: "+598",  iso: "UY", flag: "🇺🇾" },
  { name: "Uzbekistan",               code: "+998",  iso: "UZ", flag: "🇺🇿" },
  { name: "Venezuela",                code: "+58",   iso: "VE", flag: "🇻🇪" },
  { name: "Vietnam",                  code: "+84",   iso: "VN", flag: "🇻🇳" },
  { name: "Yemen",                    code: "+967",  iso: "YE", flag: "🇾🇪" },
  { name: "Zimbabwe",                 code: "+263",  iso: "ZW", flag: "🇿🇼" },
];

export const DEFAULT_COUNTRY = COUNTRY_CODES.find((c) => c.iso === "AE")!;

// Convert stored URL back to code + number
export function parsePhoneFromUrl(url: string, platform: "phone" | "whatsapp"): { code: string; number: string } {
  if (!url) return { code: "+971", number: "" };
  let cleaned = url;
  if (platform === "phone") cleaned = url.replace(/^tel:/, "");
  if (platform === "whatsapp") cleaned = "+" + url.replace(/^https:\/\/wa\.me\//, "");
  const sorted = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  const match = sorted.find((c) => cleaned.startsWith(c.code));
  if (match) return { code: match.code, number: cleaned.slice(match.code.length) };
  return { code: "+971", number: cleaned.replace(/^\+/, "") };
}

// Convert code + number to proper URL format
export function buildPhoneUrl(code: string, number: string, platform: "phone" | "whatsapp"): string {
  const digits = number.replace(/\D/g, "");
  if (!digits) return "";
  if (platform === "phone") return `tel:${code}${digits}`;
  if (platform === "whatsapp") return `https://wa.me/${code.replace("+", "")}${digits}`;
  return `${code}${digits}`;
}